<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش تخفیف ها</h5>
        <div style="flex: 1"></div>
        <button @click="print" class="btn btn-primary">
          <span
            style="transform: translateY(3px)"
            class="feather-printer"
          ></span>
        </button>
      </div>
      <div class="row px-4 not-in-print">
        <form
          autocomplete="chrome-off"
          @submit.prevent="doFilter"
          class="col-12 row"
        >
          <div class="col-6">
            <DatePickerRange
              :fromFormatType="'YYYY-MM-DD'"
              :toFormatType="'YYYY-MM-DD'"
              :fromType="'date'"
              :toType="'date'"
              :dfFType="'jYYYY-jMM-jDD'"
              :dfTType="'jYYYY-jMM-jDD'"
              v-model="filter.date"
            />
          </div>
          <div class="col-4 d-flex">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
          </div>
        </form>
      </div>
      <div id="print" class="p-4">
        <div class="print-only">
            <h4>فروشگاه عالیجناب</h4>
        </div>
        <br>
        <div
            class="d-flex mb-3 mr-2-print"
        >
            <span class="ml-1 font-bold">گزارش تخفیفات</span>
            <div v-if="appliedFilter.date.startDate">
                <span>از</span>
                <span class="font-weight-bold mx-1">تاریخ</span
                    ><span>{{ appliedFilter.date.startDate | persianDate }}</span>
                </div>
            <div class="mr-4" v-if="appliedFilter.date.endDate">
                <span>تا</span>
                <span class="font-weight-bold mx-1">تاریخ</span
                ><span>{{ appliedFilter.date.endDate | persianDate }}</span>
            </div>
        </div>
        <div class="w-100 mt-1 mb-2 mr-2-print" v-if="filter.search">
          جستجوی عبارت "{{ filter.search }}"
        </div>
        <b-table
          :total-rows="totalRows"
          :per-page="perPage"
          :current-page="currentPage"
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports"
          :filter="filter.search"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter-included-fields="['title', 'id']"
          responsive="sm"
        >
          <template v-slot:cell(id)="data">  
            <a  
              :href="`/admin/shop/orders/${data.item.order_id}`"  
              class="btn btn-primary"  
              target="_blank"  
              rel="noopener noreferrer"  
            >{{ data.item.order_id }}</a>  
          </template>  
          <template v-slot:cell(mobile)="data">
            {{ data.item.customer_name }}
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1}}
          </template>
          <template v-slot:cell(buy_price)="data">
            {{ data.item.buy_price * 10 | price }}
          </template>
          <template v-slot:cell(total_sell)="data">  
            {{ data.item.total_sell * 10 | price }}  
          </template>
          <template v-slot:cell(discount_amount)="data">
            {{ data.item.discount_amount * 10 | price }}
          </template>
          <template v-slot:cell(description)="data">  
              <span v-if="data.item.description !== 'null'">  
                  {{ data.item.description }}  
              </span>  
              <span v-else>-</span>  
          </template>
          <template #bottom-row="data">  
              <b-td>*</b-td>  
              <b-td>*</b-td>  
              <b-td>*</b-td>  
              <b-td>جمع کل:</b-td>  
              <b-td>{{ totals.discount_amount | price }}</b-td>  
              <b-td>{{ totals.amount | price }}</b-td>  
              <b-td>{{ totals.total_sell | price }}</b-td>  
              <b-td>*</b-td>  
            </template>  
        </b-table>
        <div v-if="reports && !reports.length" class="alert alert-primary">  
          اطلاعاتی موجود نیست
        </div>
      </div>
      <div class="d-flex flex-column w-100"></div>
    </div>
  </main>
</template>

<script>
import { BTable, BFormGroup, BFormInput, BTd, BPagination } from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";

function Filter() {
  this.search = "";
  this.date = {
    startDate: "",
    endDate: "",
  };
}

Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "ProductsReport",
  components: {
    ExcelDownload,
    BTd,
    DatePickerRange,
    BTable,
    BFormGroup,
    BFormInput,
    BPagination,
  },
  data() {
    return {
      disabled: false,
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "id",
          label: "شناسه",
        },
        {
          key: "mobile",
          label: "مشتری",
        },
        {
          key: "buy_time",
          label: "تاریخ ثبت",
        },
        {
          key: "discount_amount",
          label: "تخفیف (تومان)",
        },
        {
          key: "buy_price",
          label: "فروش خالص (تومان)",
        },
        {
          key: "total_sell",
          label: "فروش کل (تومان)",
        },
        {
          key: "description",
          label: "توضیحات",
        },
      ],
      page: 1,
      perPage: 200,
      totals: null,
      reports: null,
      has_discount: null,
      sortBy: null,
      sortDesc: null,
      filter: new Filter(),
      appliedFilter: new Filter(),
      currentPage: 1,
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    extraQuery() {
      return {
        start_date: this.filter.date.startDate,
        end_date: this.filter.date.endDate,
      };
    },
    totalRows() {
      return this.reports ? this.reports.length : 0;
    },
  },
  methods: {
    print() {
      window.print();  
    },
    doFilter() {
      this.loadData();
    },
    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        const today = new Date();  
        const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);  

        function formatDate(date) {  
            const year = date.getFullYear();  
            const month = String(date.getMonth() + 1).padStart(2, '0');  
            const day = String(date.getDate()).padStart(2, '0');  
            const hours = String(date.getHours()).padStart(2, '0');  
            const minutes = String(date.getMinutes()).padStart(2, '0');  
            const seconds = String(date.getSeconds()).padStart(2, '0');  

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;  
        }  
        if (!this.appliedFilter.date.startDate || !this.appliedFilter.date.endDate) {  
            this.appliedFilter.date.startDate = formatDate(startOfToday);  
            this.appliedFilter.date.endDate = formatDate(today);  
        }  
        this.disabled = true;
        const response = await this.$axios.get("admin/reports/customers-new", {
          params: {
            has_discount: 1,
            start_date: this.appliedFilter.date.startDate,
            end_date: this.appliedFilter.date.endDate,
          },
        });
        this.reports = response.data.data.reports;
        this.totals = response.data.data.totals;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>

<style>
.table-responsive-sm{
  overflow: auto;
  height: 500px;
}
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
th     { background:#eee; }
table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: flex;
    justify-content: center; 
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 100%;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>